// Screen `booking-page` (owner: scheduling, owner feedback F13): the public booking page of a meeting
// type, or the routing form that leads to one. `?invite=` carries a booking link, `?embed=1` the embedded
// look, `?lang=` the language.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicBookEntry } from '../../../features/scheduling/PublicBookEntry';

export const Route = createFileRoute('/_public/book/$slug')({
  validateSearch: z.object({
    invite: z
      .string()
      .regex(/^[a-f0-9]{40}$/)
      .optional()
      .catch(undefined),
    // One of the times a booking link offered: opens the form for exactly that time.
    at: z.iso.datetime().optional().catch(undefined),
    lang: z.enum(['en', 'de']).optional().catch(undefined),
    embed: z
      .union([z.boolean(), z.enum(['1', 'true', '0', 'false'])])
      .transform((v) => v === true || v === '1' || v === 'true')
      .optional()
      .catch(undefined),
  }),
  head: () => ({
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'referrer', content: 'no-referrer' },
    ],
  }),
  component: function BookRoute() {
    const { slug } = Route.useParams();
    return <PublicBookEntry key={slug} slug={slug} search={Route.useSearch()} />;
  },
});
